import { comics } from "@/mocks/comics";

export default function PopularGrid() {
  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
              <i className="ri-fire-line text-primary-600"></i>
              热门漫画
            </span>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              本周最热，大家都在追
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              根据实时热度与读者口碑精选的爆款连载与完结佳作，热门不迷路，冷门也有宝。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {comics.map((c) => (
            <a
              key={c.id}
              href="#hot"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.title} 漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-black/55 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur">
                  {c.status}
                </span>
                <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded bg-background-50/90 px-2 py-0.5 text-xs font-bold text-foreground-950">
                  <i className="ri-star-fill text-accent-500"></i>
                  {c.score}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-3 pt-8">
                  <p className="text-sm font-semibold text-background-50">{c.chapter}</p>
                </div>
              </div>
              <div className="flex flex-col gap-2 p-3 md:p-4">
                <div className="flex items-center justify-between">
                  <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">
                    {c.title}
                  </h3>
                  <span className="shrink-0 text-xs text-foreground-500">{c.category}</span>
                </div>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {c.desc}
                </p>
                <div className="mt-1 flex flex-wrap gap-1.5">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#collection"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            浏览更多漫画
          </a>
        </div>
      </div>
    </section>
  );
}